import {FormElement} from '@esgi/ui/form';
import {styled} from '@esgi/ui/theme';

export const FormElementRoot = styled(FormElement, {
	marginBottom: 'unset !important',
});
